import request from '@/utils/request'

export default {
    getList: async (params) => {
        return ''
        return await request.get('/app/dicts', { params, returnAll: true })
    },

}

